import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import DocumentMeta from 'react-document-meta';
import StateCoverageGroupedSearch from '../components/StateCoverage/StateCoverageGroupedSearch';

const meta = {
  title: 'Providers | Free medication abortion',
  description: '',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: '',
    },
    property: {
      'og:title': 'Providers | Free medication abortion',
      'og:description': '',
      'og:image': '',
    },
  },
};

export default function Providers() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <DocumentMeta {...meta}>
      <div className="about-page">
        <div className="page-title dark-background text-start contact-bg">
          <div className="container position-relative">
            <h1>Providers</h1>
            <nav className="breadcrumbs text-start">
              <ol className="justify-content-start">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="current">Providers</li>
              </ol>
            </nav>
          </div>
        </div>

        <section className="about section light-background py-4">
          <div className="container section-title pb-0" data-aos="fade-up">
            <div className="col-lg-12 content section-title pb-3">
              <p>
                <strong>
                  This site is an information source. It does not give medical
                  or legal advice or sell abortion pills.
                </strong>
              </p>
              <p className="mt-2">
                For your safety and the providers' safety, please set up a
                secure, free email account on{' '}
                <a href="https://proton.me/mail" target="_blank">
                  {' '}
                  protonmail
                </a>{' '}
                to use when contacting them. iCloud email is not compatible with
                our system.
              </p>
              <p className="mt-2">
                <strong>
                  Include in your email - your name, full mailing address,
                  estimated number of weeks gestation and the date of your
                  positive pregnancy test.
                </strong>
              </p>
              <p className="mt-2">
                PLEASE CONFIRM YOUR INFORMATION HAS THE CORRECT ADDRESS - only
                one kit is shipped per request and the most frequent reason for
                non-delivery is an incorrect address or missing address
                information. Make sure to include ALL information - name,
                street, city, state, zip code and apartment number if available.
              </p>
            </div>
          </div>
        </section>

        <StateCoverageGroupedSearch />
      </div>
    </DocumentMeta>
  );
}
